var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4.25C6.30964 4.25 5.75 4.80964 5.75 5.5C5.75 5.91421 5.41421 6.25 5 6.25C4.58579 6.25 4.25 5.91421 4.25 5.5C4.25 3.98122 5.48122 2.75 7 2.75C8.51878 2.75 9.75 3.98122 9.75 5.5C9.75 6.66431 9.0267 7.65786 8.00765 8.05931C7.90505 8.09973 7.82589 8.15689 7.78156 8.20659C7.75962 8.23119 7.7522 8.24633 7.75 8.25261C7.74859 8.66563 7.41334 9 7 9C6.58579 9 6.25 8.66421 6.25 8.25C6.25 7.38526 6.94646 6.86517 7.45785 6.6637C7.92296 6.48047 8.25 6.02751 8.25 5.5C8.25 4.80964 7.69036 4.25 7 4.25Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5C7.55228 11.5 8 11.0523 8 10.5C8 9.94772 7.55228 9.5 7 9.5C6.44772 9.5 6 9.94772 6 10.5C6 11.0523 6.44772 11.5 7 11.5Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7 12.5C10.0376 12.5 12.5 10.0376 12.5 7C12.5 3.96243 10.0376 1.5 7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 10.0376 3.96243 12.5 7 12.5Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.a6a35b69c4acd901427d54d08152dede.svg";
export { ForwardRef as ReactComponent };